<script setup>
import {computed} from 'vue'
import hljs from "highlight.js/lib/core";
import json from 'highlight.js/lib/languages/json';

hljs.registerLanguage('json', json);

const props = defineProps({
    obj: {
        type: Object,
        default: () => {},
    },
});

const prettyJson = computed(() => {
    const json = JSON.stringify(
        props.obj,
        null,
        '  '
    );
    return hljs.highlight(json, { language: 'json' }).value;
})

</script>

<template>
    <div style="font-size: 80%">
        <pre><!-- eslint-disable vue/no-v-html --><code v-html="prettyJson"></code><!--eslint-enable--></pre>
    </div>
</template>
